import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Tooltip,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

/**
 * This component displays a popup with error messages related to PSL materials.
 * @param {InvalidPSLMaterialIdPopup.propTypes} props
 * @return {JSX.Element}
 */
export function InvalidPSLMaterialIdPopup(props) {
    const [tooltipContent, setTooltipContent] = useState('Copy content?');
    const title = `Your request${props.multipleRequests ? 's have' : ' has'} not been ${props.typeOfAction}.`;
    const text1 = 'You need to create a new request in alignment with the actual PSL content.';
    const text2 = 'The action cannot be completed as the status of below materials changed in the PSL:';

    const handleCopy = () => {
        let content = '';

        content += `${title}\n`;
        content += `${text1}\n`;
        content += `${text2}\n\n`;

        content += 'EPR\tLine\tMaterial\tCurrent PSL Status\n';

        props.materials.forEach((row) => {
            content += `${row.EPR}\t${row.line}\t${row.material}\t${row.currentPSLStatus}\n`;
        });

        navigator.clipboard.writeText(content).then(
            () => {
                setTooltipContent('Content copied');
                setTimeout(() => setTooltipContent('Copy content?'), 3000);
            },
            (err) => {
                setTooltipContent('Error while copying');
                setTimeout(() => setTooltipContent('Copy content?'), 3000);
            },
        );
    };

    return (
        <Dialog onClose={props.onClose} open={props.open} aria-labelledby="error-popup" fullWidth={true} maxWidth='md'>
            <div style={{display: 'flex'}}>
                <div
                    style={{
                        backgroundColor: 'red',
                        width: '20%',
                        height: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: '50px',
                        justifyContent: 'center',
                    }}
                >
                    <i className="material-icons" style={{color: 'white'}}>
                        {'error'}
                    </i>
                </div>
                <div style={{width: '100%'}}>
                    <DialogTitle id="popup-title">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <span>{title}</span>
                            <Tooltip title={tooltipContent}>
                                <IconButton onClick={handleCopy} aria-label="copy table" size="large">
                                    <ContentCopyIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{marginBottom: '0.5rem'}}>{text1}</DialogContentText>
                        <DialogContentText>{text2}</DialogContentText>
                        <TableContainer component={Paper} sx={{marginTop: '1rem'}}>
                            <Table aria-label="materials table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>EPR</TableCell>
                                        <TableCell>Line</TableCell>
                                        <TableCell>Material</TableCell>
                                        <TableCell>Current PSL Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.materials.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.EPR}</TableCell>
                                            <TableCell>{row.line}</TableCell>
                                            <TableCell>{row.material}</TableCell>
                                            <TableCell>{row.currentPSLStatus}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onClose}>Ok</Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

InvalidPSLMaterialIdPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    materials: PropTypes.array.isRequired,
    typeOfAction: PropTypes.string.isRequired,
    multipleRequests: PropTypes.bool,
    onClose: PropTypes.func,
};

InvalidPSLMaterialIdPopup.defaultProps = {
    multipleRequests: false,
};
